// import { useNavigate } from "react-router";
import { useHttpUtil } from "context/HttpContext";
import Stats from "libs/utils/stats";
import Tools from "libs/utils/Tools";

export function useProject() : [(projectId ?: string) => Promise<void>, (projectId: string, fromType?: number) => void]{
    // const navigate = useNavigate();
    const httpUtil = useHttpUtil();

    const gotoAdd = async (projectId : string = '') : Promise<void> => {
        Stats.google('Create New Project');
        const data = await httpUtil.post('/biz/project/add', {
            projectId
        })
        if(!data.errCode){
            gotoEditor(data.data.projectId)
        }
    }

    const gotoEditor = (projectId: string, fromType?: number) : void => {
        if(fromType == 1) Stats.google('Project Tutorials');
        location.href = Tools.disponseUrl('/project/' + projectId)
    }

    return [gotoAdd, gotoEditor];
}